import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { useMemo } from 'react';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import UsageTracker from '../../utils/UsageTracker';
import { PageSectionHeading } from '../SectionHeading';
import { RouterLink } from '../AcademyLinks';
import { View } from 'foundations-components/components/View';
import { getMyLearningUrl } from '../../features/myLearning/myLearningRouting';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const MostPopularCertificatesHeader = ({
  numCompletedCertificates
}) => {
  const {
    isTablet,
    isMobile
  } = useMediaQuery();
  const showCompletedCertificatesCount = !isMobile && !isTablet && numCompletedCertificates > 0;
  const certificatesCompletedCount = useMemo(() => /*#__PURE__*/_jsx(RouterLink, {
    onClick: () => UsageTracker.track('interaction', {
      action: 'most-popular-certificates-certificates-completed-clicked'
    }),
    to: `${getMyLearningUrl()}?progressStatus=COMPLETED&awardType=ONLY_SHOW_CERTIFICATE_COURSES`,
    children: showCompletedCertificatesCount && /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.mostPopularCertificates.certificatesCompleted",
      options: {
        numCertificates: numCompletedCertificates
      }
    })
  }), [showCompletedCertificatesCount, numCompletedCertificates]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TFlex, {
      align: "start",
      justify: "between",
      marginBlockEnd: "0",
      wrap: "wrap",
      children: /*#__PURE__*/_jsx(PageSectionHeading, {
        marginBlockEnd: "0",
        subtitle: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "200",
          children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "learningCenter.mostPopularCertificates.genericSubtitle"
          }), !isMobile && certificatesCompletedCount]
        }),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.mostPopularCertificates.genericTitle"
        })
      })
    }), isMobile && /*#__PURE__*/_jsx(View, {
      as: "div",
      marginBlockEnd: isMobile ? '0' : '200',
      children: certificatesCompletedCount
    })]
  });
};
export default MostPopularCertificatesHeader;